import React, { useState } from 'react';

const FAQ_ITEMS = [
  {
    question: 'Welche Daten sieht die KI?',
    answer: 'Personenbezogene Kontaktdaten wie E-Mail-Adressen, Telefonnummern und bereits bekannte Namen aus deinem Team werden vor jeder Anfrage automatisch durch einen Platzhalter ersetzt. Die KI bekommt diese echten Werte nie zu sehen – nur der Platzhalter wird übermittelt.',
  },
  {
    question: 'Sieht die KI trotzdem meinen restlichen Text?',
    answer: 'Ja – der übrige Gesprächsinhalt wird normal verarbeitet, damit dir wirklich geholfen werden kann. Nur die automatisch erkannten sensiblen Datentypen werden ersetzt.',
  },
  {
    question: 'Kann ich nachvollziehen, was erkannt und ersetzt wurde?',
    answer: 'Ja. Nach jeder Anfrage zeigt dir ein Badge genau, welche Datentypen erkannt und geschützt wurden.',
  },
  {
    question: 'Werden meine Daten gespeichert?',
    answer: 'Ja, wie in unserer Datenschutzerklärung beschrieben. Welcher Platzhalter zu welchem echten Wert gehört, wird ausschließlich serverseitig gespeichert – für niemanden sonst einsehbar, auch nicht für Administratoren.',
  },
  {
    question: 'Funktioniert das auch für Meeting-Aufnahmen und Audiodateien?',
    answer: 'Ja. Transkripte und Besprechungsprotokolle werden vor der KI-Verarbeitung genauso geschützt, und du kannst die Audiodatei optional automatisch nach der Verarbeitung löschen lassen.',
  },
  {
    question: 'Muss ich etwas einstellen, damit das funktioniert?',
    answer: 'Nein. Der Schutz läuft automatisch im Hintergrund bei jeder KI-Anfrage – ohne dass du etwas aktivieren oder konfigurieren musst.',
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className="faq-item">
      <button
        type="button"
        className="faq-item__question"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span>{item.question}</span>
        <span className="faq-item__chevron" aria-hidden="true">{isOpen ? '▾' : '▸'}</span>
      </button>
      {isOpen && <p className="faq-item__answer">{item.answer}</p>}
    </div>
  );
}

function PrivacyFaq() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="privacy-faq reveal" id="datenschutz-faq">
      <div className="section-header">
        <h2>Häufige Fragen zum Datenschutz</h2>
        <p>Was du über den automatischen Schutz deiner Daten wissen solltest.</p>
      </div>
      <div className="faq-list">
        {FAQ_ITEMS.map((item, i) => (
          <FaqItem
            key={item.question}
            item={item}
            isOpen={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? null : i)}
          />
        ))}
      </div>
    </section>
  );
}

export default PrivacyFaq;
